import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { ModalService } from '../../../../core/services/modal.service';
import { SafePipe } from '../../../pipes/safe.pipe';

@Component({
  selector: 'app-checkout-iframe-modal',
  standalone: true,
  imports: [CommonModule, SafePipe],
  templateUrl: './checkout-iframe-modal.component.html',
})
export class CheckoutIframeModalComponent {
  checkoutLinkUrl: string | null = null;

  constructor(
    private modalService: ModalService
  ) {
    const data = ModalDataService.getData();
    this.checkoutLinkUrl = data?.checkoutLink ?? null;
  }

  close(): void {
    this.modalService.closeAll();
  }
}
